<template>
  <div id="songs">
    <h1>歌詞列表</h1>
    <div id="list">
      <div class="item" v-for="(song, index) in list" :key="song.id" >
      <span>{{ index +1 }}. </span>
      <a @click="goTo(song.id)">
        {{song.name}}
      </a>
    </div>
    </div>
  </div>
</template>

<style scoped>
#songs { @apply flex flex-col justify-center;}
h1 { @apply text-6xl font-bold mb-8 mt-4;}
#list { @apply mx-auto;}
.item { @apply text-2xl text-left mb-3 whitespace-nowrap; }
.item>a { @apply cursor-pointer;}
.item>a:hover { color: #42b983; }
@media (max-width: 425px) {
  h1 { @apply text-3xl font-semibold mb-6;}
  .item { @apply text-lg; }
}
</style>

<script>
import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import useAirtable from '@/stores/airtable';

export default defineComponent({
  name: 'song',
  setup() {
    const vm = getCurrentInstance();
    const db = useAirtable();
    if (!db.lyrics) { db.loadLyrics(); }
    if (!db.sheet) { db.loadSheet(); }
    const goTo = (songId) => {
      if (songId) { vm.proxy.$router.push({ name: 'Song', params: { id: songId } }); }
    };
    return {
      db, goTo,
    };
  },
  computed: {
    list() {
      const list = []; if (!this.db.lyrics) { return list; }
      this.db.songsList.forEach((id) => {
        const name = this.db.lyrics[id] ? this.db.lyrics[id].name : '';
        list.push({ id, name });
      });
      return list;
    },
  },
});
</script>
